import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
export enum SnackBarType {
  SUCCESS,
  INFO,
  WARNING,
  ERROR,
}

export enum SnackBarDuration {
  LENGTH_INDEFINITE,
  LENGTH_SHORT = 2000,
  LENGTH_LONG = 7000,
}

@Injectable()
export class SnackbarAlertService {
  private _snackBar: MatSnackBar = inject(MatSnackBar);

  showSnackBar(message: string, snackBarType: SnackBarType, duration: SnackBarDuration = SnackBarDuration.LENGTH_LONG, action: string = '') {
    let className = '';

    switch (snackBarType) {
      case SnackBarType.SUCCESS:
        className = 'custom-snackbar-success';
        break;
      case SnackBarType.INFO:
        className = 'custom-snackbar-info';
        break;
      case SnackBarType.WARNING:
        className = 'custom-snackbar-warning';
        break;
      case SnackBarType.ERROR:
        className = 'custom-snackbar-error';
        break;
    }

    this._snackBar.open(message, action, {
      duration: duration,
      panelClass: [className],
    });
  }
}
